<template>
  <div>
    <offline-registration-list v-show="tabType === 1" @handleShow="handleShow" />
    <!-- 详情页面可以后续添加 -->
    <!-- <offline-registration-show v-if="tabType === 2" :rowId="id" @handleShow="handleShow"/> -->
  </div>
</template>

<script>
import offlineRegistrationList from './list.vue'
// import offlineRegistrationShow from './show.vue'

export default {
  components: {
    offlineRegistrationList
    // offlineRegistrationShow
  },
  data() {
    return {
      tabType: 1,
      id: null
    }
  },
  methods: {
    handleShow(id, type) {
      this.tabType = type
      this.id = id
      console.log('id: ', id)
    }
  }
}
</script>

<style>
</style>

